import illustrationRetina from 'marketing-website/media/images/pages/contact-us/illustration@2x.jpg';
import pressRetina from 'marketing-website/media/images/pages/contact-us/press@2x.png';
import salesRetina from 'marketing-website/media/images/pages/contact-us/sales@2x.png';
import supportRetina from 'marketing-website/media/images/pages/contact-us/supportNew@2x.png';
import gridRetina from 'marketing-website/media/images/pages/contact-us/grid@2x.jpg';

const assets = {
  illustration: {
    alt: '',
    src: illustrationRetina,
  },
  press: {
    alt: '',
    src: pressRetina,
  },
  sales: {
    alt: '',
    src: salesRetina,
  },
  support: {
    alt: '',
    src: supportRetina,
  },
  office: {
    alt: '',
    src: gridRetina,
    maxWidth: 804,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/contact-us/assets.js